module.exports = __webpack_public_path__ + "static/media/dashboard-teacher-assignments-overview.cdacd7c1.svg";